import React from 'react';
import Analytics from '../../../pages/Analytics';

const AIAnalytics: React.FC = () => {
  return <Analytics />;
};

export default AIAnalytics;